import { render, staticRenderFns } from "./TalkLogin.vue?vue&type=template&id=376e8cdf&scoped=true&"
import script from "./TalkLogin.vue?vue&type=script&lang=js&"
export * from "./TalkLogin.vue?vue&type=script&lang=js&"
import style0 from "./TalkLogin.vue?vue&type=style&index=0&id=376e8cdf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376e8cdf",
  null
  
)

export default component.exports